module.exports = __webpack_public_path__ + "static/media/store-national-coop-grocers.3d3ef00f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/store-national-coop-grocers.jpg
// module id = 234
// module chunks = 0